import Segment from '@/Segment';
import MemberApi from '@/api/MemberApi';

import Intercom from '@/Intercom';
import Sentry from '@/Sentry';

const state = {
  authenticated: false,
  activeMember: undefined,
  products: undefined,
};

const actions = {
  async init({ commit }) {
    const [activeMember, { products }] = await Promise.all([MemberApi.getActiveMember(), MemberApi.getProducts()]);
    commit('setActiveMember', activeMember);
    commit('setProducts', products);
    Segment.identify(activeMember.customerId);
    Sentry.setTag('riseupAccountId', activeMember.customerId);
    await Intercom.boot(activeMember._id, { riseupAccountId: activeMember.customerId });
  },
};

const mutations = {
  setAuthenticated(state) {
    state.authenticated = true;
  },
  setActiveMember(state, activeMember) {
    state.activeMember = activeMember;
  },
  setProducts(state, products) {
    state.products = products;
  },
};

const getters = {
  authenticated: state => state.authenticated,
  activeMemberFirstName: state => state.activeMember && state.activeMember.firstNamePiiValue,
  activeMemberLastName: state => state.activeMember && state.activeMember.lastNamePiiValue,
  activeMemberEmail: state => state.activeMember && state.activeMember.emailPiiValue,
  hasCashflowProduct: state => state.products && state.products.some(product => product === 'cashflow'),
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
